/**
 * スポットID生成ユーティリティ
 *
 * スポットID形式: S + 9文字のランダム英数字
 * 紛らわしい文字（I, O, 0, 1）は除外
 */

const CANDIDATE_CHARS = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";

/**
 * スポットIDを自動生成する
 * @returns 生成されたスポットID（例: SABC23DEF4）
 */
export const generateSpotId = (): string => {
  const randomChars = Array.from({ length: 9 }).map(() => {
    return CANDIDATE_CHARS[Math.floor(Math.random() * CANDIDATE_CHARS.length)];
  });
  return "S" + randomChars.join("");
};
